import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import EmptyAvatar from "./components/EmptyAvatar.js";
import TextAvatar from "./components/TextAvatar.js";
import ErrorAvatar from "./components/ErrorAvatar.js";
import { rootClass } from "./constant.js";
import AvatarContainer from "./components/AvatarContainer.js";
function Avatar(props) {
    const { src, name, size = 'medium', onClick } = props;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const handleLoad = ()=>{
        setLoading(false);
    };
    const handleError = ()=>{
        setLoading(false);
        setError(true);
    };
    if (!src && !name) return /*#__PURE__*/ jsx(EmptyAvatar, {
        ...props
    });
    if (!src) return /*#__PURE__*/ jsx(TextAvatar, {
        ...props
    });
    const renderAvatar = ()=>{
        if (error) return /*#__PURE__*/ jsx(ErrorAvatar, {
            ...props
        });
        return /*#__PURE__*/ jsxs(Fragment, {
            children: [
                loading && /*#__PURE__*/ jsx(EmptyAvatar, {
                    ...props
                }),
                /*#__PURE__*/ jsx(AvatarContainer, {
                    ...props,
                    style: {
                        opacity: loading ? 0 : 1,
                        position: loading ? 'absolute' : 'relative'
                    },
                    children: /*#__PURE__*/ jsx("img", {
                        loading: "lazy",
                        className: `${rootClass}__${size}`,
                        style: props.style,
                        src: src,
                        alt: "\u5934\u50CF",
                        onClick: onClick,
                        onLoad: handleLoad,
                        onError: handleError
                    })
                })
            ]
        });
    };
    return renderAvatar();
}
export { Avatar as default };
